import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';
import { getRole } from '../../utils/role';

const initialState = {
  reports: [],       // Stores the list to display
  allReports: [],    // Stores the full list for client-side filtering
  source: '',
  searchKeyword: '',
  currentPage: 1,
  totalPages: 1,
  status: 'idle',
  error: null,
  currentRequestId: undefined,
};

export const fetchReports = createAsyncThunk(
  'reports/fetchReports',
  async ({ page = 1, limit = 15, source, keyword }, { rejectWithValue }) => {
    try {
      const role = getRole();

      // --- FARMER ---
      if (role === 'FARMER') {
        const { data } = await axiosInstance.get('user/reports');
        return { mode: 'FARMER', data: data };
      }

      // --- FIELD OFFICER ---
      if (role === 'FIELD_OFFICER') {
        const { data } = await axiosInstance.get('field-officer/reports');
        return { mode: 'FIELD_OFFICER', data: data.reports };
      }

      // --- PARTNER ---
      if (role === 'PARTNER' || role === 'TEAM_MEMBER') {
        const { data } = await axiosInstance.get('/admin/reports');
        return { mode: 'PARTNER', data };
      }

      // --- SUPPORT (Default) ---
      let url = `/super-admin/reports?page=${page}&limit=${limit}`;
      if (source) url += `&source=${source}`;
      if (keyword) url += `&keyword=${keyword}`;

      const { data } = await axiosInstance.get(url);
      return { mode: 'SUPPORT', data };

    } catch (err) {
      return rejectWithValue(
        err.response?.data?.msg || 'An error occurred'
      );
    }
  }
);

export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReports.pending, (state, action) => {
        state.status = 'loading';
        state.error = null;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(fetchReports.fulfilled, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) {
            return;
        }

        state.currentRequestId = undefined;
        state.status = 'succeeded';

        const { mode, data } = action.payload;

        if (mode === 'SUPPORT') {
            state.reports = data.reports;
            state.totalPages = Math.ceil(data.totalCount / 15);
        } else {
            state.allReports = data;
            state.reports = data;
        }
      })
      .addCase(fetchReports.rejected, (state, action) => {
        if (state.currentRequestId !== action.meta.requestId) {
            return;
        }

        state.currentRequestId = undefined;
        state.status = 'failed';
        state.error = action.payload;
      })
  },
});

export const { setCurrentPage } = reportsSlice.actions;
export default reportsSlice.reducer;